import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled, { css } from "styled-components";
import Icon from "~/components-shared/Icon";
const Wrapper = styled.div`
  ${_ref => {
  let {
    $s,
    theme
  } = _ref;
  return theme.spacing.resolve(theme, $s);
}};
  ${_ref2 => {
  let {
    $center
  } = _ref2;
  return $center ? css`
          width: 100%;
          display: flex;
          justify-content: center;
        ` : css`
          display: inline-block;
        `;
}}

  svg {
    vertical-align: middle;
    animation: rotate 2s linear infinite;
    z-index: 2;

    & .path {
      stroke-linecap: round;
      animation: dash 1.5s ease-in-out infinite;
    }
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`;
const Spinner = _ref3 => {
  let {
    color = "inherit",
    center = false,
    scale = 10,
    s = {},
    ...rest
  } = _ref3;
  return /*#__PURE__*/React.createElement(Wrapper, {
    $center: center,
    $s: s
  }, /*#__PURE__*/React.createElement(Icon, _extends({
    src: "spinner",
    color: color,
    scale: scale
  }, rest)));
};
export default Spinner;